// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o4-0";
export var buttonContainer = "_o4-3";
export var cancelButton = "_o4-4";
export var headerSection = "_o4-6";
export var headerTitle = "_o4-9";
export var messageSideLeft = "_o4-1";
export var messageSideRight = "_o4-2";
export var orderNumberContainer = "_o4-7";
export var orderNumberLabel = "_o4-8";
export var submitButton = "_o4-5";